import React from "react";
import { Button, Container, Image } from "react-bootstrap";
import cta from "../../../../Asset/cta-ng.png";
import "./Shallwetalk.css";
import { useNavigate } from "react-router-dom";

const Shallwetalk = () => {
  const navigate = useNavigate();

  const hendleClick = () => {
    navigate("/ContactUs");
  };

  return (
    <>
      <section className="companyover-section-5">
        <Container>
          <div className="row sec-5-row">
            <div className="col-xl-8 col-md-8 cta-content">
              <div className="sec-5-cta-card">
                <h3>Shall we talk about Upgrading your Business?</h3>
                <Button className="btn btn-primary" onClick={hendleClick}>
                  Contact Us Today{" "}
                </Button>
              </div>
            </div>
            <div className="col-xl-4 col-md-4 cta-img">
              <div className="cta-bg">
                <Image src={cta} className="w-100" />
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};
export default Shallwetalk;
